// extracted by mini-css-extract-plugin
export default {"icon-button":"Stores_icon-button__OPZnL","card-body":"Stores_card-body__P-9n0","fa-lg":"Stores_fa-lg__eD2ju","actionBtns":"Stores_actionBtns__JgaXC"};